<template>
  <div class="introduction_page">

    <!-- 顶部定位 -->
    <div class="header_wrap">
      <div class="header_icon">
        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/agp_index_stock2.png" alt="爱股票">
      </div>
      <div class="header_menu">
        <div class="fixed-menu" :class="{'close-menu': menuType}" @click.stop.prevent="toggleType"><i></i><i></i><i></i></div>
      </div>
    </div>

    <!-- 下载APP -->
    <div class="header" ref="header">

      <div class="header_content">专业股市投资者社区</div>
      <div class="header_summary">
        <dl>
          <dt><img src="@/assets/img/introduction_0730/操盘@2x.png" alt=""></dt>
          <dd>高手互动</dd>
        </dl>
        <dl>
          <dt><img src="@/assets/img/introduction_0730/选股@2x.png" alt=""></dt>
          <dd>智能选股</dd>
        </dl>
        <dl>
          <dt><img src="https://cdncos.aigupiao.com/assets/pc/img/2023/agp_index_stock.png" alt=""></dt>
          <dd>实时行情</dd>
        </dl>
        <dl>
          <dt><img src="@/assets/img/introduction_0730/资讯@2x.png" alt=""></dt>
          <dd>股市资讯</dd>
        </dl>
      </div>

      <div class="download_app_btn" @click="toDownloadApp">
        下载 爱股票APP
      </div>
      <div class="header_bg">
        <img src="@/assets/img/introduction_0730/头部背景@2x.png" alt="">
      </div>
    </div>

    <!-- 主体部分 -->
    <div class="content_wrap">
      <!-- 轮播图 -->
      <div class="introduction_item" ref="Introduction">
        <h3 class="introduction_item_titile">产品介绍</h3>
        <p class="introduction_p"><span>爱股票</span>，专业股市投资者社区，汇聚股市高手，分享实战选股策略、股票投资组合、实时行情、资讯研报等服务，已涵盖A股/港股/基金/美股/等领域，拥有超百万高端用户。</p>

        <div class="introduction_item_content">
          <div class="introduction_item no_mt introduction_item_swipe">
            <div class="introduction_item_content_swipe">
              <div class="step_wrap">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div
                        class="swiper-slide"
                        v-for="(item, i) in stepImgArr"
                        :key="'ing_' + i"
                    >
                      <img class="swiper-img" :src="item" />
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品介绍 -->
      <div class="introduction_item" ref="Advantage" style="margin-top: 47px;">
        <h3 class="introduction_item_titile">产品功能</h3>

        <div class="introduction_item_content">
          <div class="rank_info rank_info_1"><span>社区</span></div>
          <div class="introduction_item_text">
            <p>与股市专家和实战高手同台交流，盘中实时分享选股思路，指点市场方向，并实时答疑解惑。</p>
          </div>
          <div class="introduce_wrap">
            <div class="introduce_1"></div>
          </div>
          <div class="rank_info rank_info_2"><span>行情</span></div>
          <div class="introduction_item_text">
            <p>即时报价、短线盯盘、资金动向、异动提醒、开户交易、新闻、公告、研报、论坛等股票信息一览无余。</p>
          </div>
          <div class="introduce_wrap">
            <div class="introduce_2"></div>
          </div>
          <div class="rank_info rank_info_3"><span>组合</span></div>
          <div class="introduction_item_text">
            <p>查看实战高手（智能投顾）投资组合和调仓记录，跟实战高手同步，让智能大数据帮你选牛股。</p>
          </div>
          <div class="introduce_wrap">
            <div class="introduce_3"></div>
          </div>
          <div class="rank_info rank_info_4"><span>专栏</span></div>
          <div class="introduction_item_text">
            <p>邀请知名专家撰写深度文章，权威分析师做题材挖掘，精选研报，价值投资。</p>
          </div>
          <div class="introduce_wrap">
            <div class="introduce_4"></div>
          </div>
          <div class="rank_info rank_info_5"><span>资讯</span></div>
          <div class="introduction_item_text">
            <p>第一时间发布影响市场的重大消息，掌握股票一手资讯。</p>
          </div>
          <div class="introduce_wrap">
            <div class="introduce_5"></div>
          </div>
        </div>
      </div>

      <!-- 关于我们 -->
      <div class="introduction_item" ref="AboutUs">
        <h3 class="introduction_item_titile">关于我们</h3>

        <div class="introduction_item_content about_us">
          <div class="content">
            <!-- <p>“爱股票”由北京亿客科技开发，中讯证券运营。北京亿客科技是一家以移动互联网财经产品研发及信息技术应用为主的高科技公司，国家级高新技术企业，旗下拥有持牌证券机构“中讯证研”，已获知名机构多轮融资，与十多家券商机构建立了战略合作关系。</p> -->
            <p>“爱股票”由北京亿客科技开发。北京亿客科技是一家以移动互联网财经产品研发及信息技术应用为主的高科技公司，国家级高新技术企业。</p>
          </div>
        </div>
      </div>

      <!-- 下载APP -->
      <div class="download_app_btn" @click="toDownloadApp" ref="Download">
        下载 爱股票APP
      </div>
    </div>

    <!-- 底部样式 -->
    <!-- <footer style="display: none;">
      <p>CopyRight(C) 2015-2021 www.aigupiao.com All</p>
      <p>Rights Reserved 北京亿客科创信息技术有限公司版权所有</p>
      <p>备案编号： 京ICP备15042420号-3</p>
    </footer> -->

    <!-- 右边菜单 -->
    <transition name="modal" mode="in-out">
      <div class="modal modal-jc" @click.stop.prevent="toggleType" style="z-index: 1000;" v-if="menuType">
        <div class="modal-bg" style="background-color: rgba(255, 255, 255, 0.95);"></div>
        <div class="modal-scroll">
          <div role="dialog" class="modal-dialog">
            <div class="modal-content">
              <div class="modal-item" @click.stop.prevent="fixedTo('Introduction')">产品介绍</div>
              <div class="modal-item" @click.stop.prevent="fixedTo('Advantage')">产品功能</div>
              <div class="modal-item" @click.stop.prevent="fixedTo('AboutUs')">关于我们</div>
              <div class="modal-item onCheck" @click.stop.prevent="fixedTo('Top')">下载应用</div>
              <div class="modal-item" @click.stop.prevent="fixedTo('Top')">进入爱股票</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Swiper from "swiper";
import Api from "@/api/home/index.js";
import "swiper/css/swiper.min.css";

const step_1 = require("@/assets/img/introduction_0730/screen_1.png");
const step_2 = require("@/assets/img/introduction_0730/screen_2.png");
const step_3 = require("@/assets/img/introduction_0730/screen_3.png");
const step_4 = require("@/assets/img/introduction_0730/screen_4.png");
export default {
  name: "introductionPage",
  components: {},
  data() {
    return {
      randomStr: Math.random().toString(36).slice(-4),
      stepImgArr: [
        step_1,
        step_2,
        step_3,
        "https://cdncos.aigupiao.com/assets/wap/img/home/home_zx_lb.png",
      ],
      stepIndex: 0,
      downloadAppUrl: "http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui",
      menuType: false,
      menuList: [
        {
          title: "Introduction",
          name: "产品介绍",
          use: true
        }, {
          title: "Advantage",
          name: "产品功能",
          use: true
        }, {
          title: "AboutUs",
          name: "关于我们",
          use: true
        }, {
          title: "Download",
          name: "下载应用",
          use: true
        }, {
          title: "Top",
          name: "进入爱股票",
          use: false
        }
      ]
    };
  },
  created() {
    this.getShareInfo();
  },
  mounted() {
    // let nowDate = new Date()/1000;
    // if(nowDate < 1670414400) {
    //     $('html,body,.introduction_page').css({
    //         'filter': 'grayscale(100%)'
    //     })
    // }
    var that = this;
    this.$nextTick(() => {
      var swiper1 = new Swiper(".swiper-container", {
        autoplay: {
          delay: 3000, // 默认的停顿间隔
          disableOnInteraction: false
        },
        loop: true,		// 开启循环
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            that.stepIndex = this.activeIndex;
            // alert(this.activeIndex); //切换结束时，告诉我现在是第几个slide
          },
        },
      });
    });
  },
  methods: {
    async getShareInfo() {
      let res = await Api.getShareInfo();
      console.info(res,'res', res && res.status == 'success')
      if(res && res.share_title != '') {
        let data = res;
        let share_obj={
            share_open :data.share_open,
            share_logo : data.share_logo || "https://cdncos.aigupiao.com/assets/wap/img/logo80x80.png",
            share_link : data.share_link,
            share_content : data.share_content,
            share_title : data.share_title,
        }
        console.info(share_obj)
        this.$share(share_obj);
      }
    },
    // 定位样式
    fixedTo(type) {
      /* 默认高度 */
      var top = 0;

      /* Top 默认为回到顶部 其它选项会获取他们距离父级顶部的距离 */
      if(type !== 'Top') {
        top = this.$refs[type].offsetTop + this.$refs['header'].clientHeight;
      } else {
        /* 如果点击了进入爱股票则直接跳转下载APP的页面 */
        location.href = this.downloadAppUrl;
      }

      /* 滚动定位到执行位置 */
      window.scrollTo({
        top,
        behavior: "smooth"
      });

      /* 关闭浮层 */
      this.toggleType();
    },
    // 切换蒙层
    toggleType() {
      // 判断蒙层状态
      /* 暂时注释改功能 */
      /*if(!this.menuType) {
        var menuList = this.menuList, headerHeight = this.$refs['header'].clientHeight,wHeight = window.scrollY,tList = [];
        // 如果是闭合状态 - 获取聚顶高度 - 然后高亮选项
        for(var i=0,ilen=menuList.length;i<ilen;i++) {
          if(menuList[i].use) {
            var topValue = this.$refs[menuList[i].title].offsetTop + headerHeight;
            tList[i] = topValue;
          }
        }
        tList.unshift(0)
        console.info(tList);
        for(var i=0,ilen=tList.length;i<ilen;i++) {
          if((wHeight<tList[i])) {

            console.info(i)
            break;
          }
        }
      }*/
      this.menuType = !this.menuType;
    },
    // 跳转下载链接
    toDownloadApp() {
      location.href = this.downloadAppUrl;
    },
    async getWxShareCommon() {

    },
  },
};
</script>

<style scoped lang="scss">
.p_t_5 {
  padding-top: 5px;
}
.p_t_10 {
  padding-top: 10px;
}
.p_t_8 {
  padding-top: 8px;
}

.p_b_14 {
  padding-bottom: 14px;
}

.introduction_page {
  position: relative;
  padding-top: 57.5px;
  padding-bottom: 15px;
  background-color: white;
  .header {
    position: relative;
    background: #ffffff;
    padding: 40px 0 0;
  }
  .header_b_p {
    width: 100%;
    height: 107px;
    background: #ffffff;
    .slide_down_text {
      width: 100%;
      height: 21px;
      font-size: 15px;
      color: #ff781d;
      line-height: 21px;
      text-align: center;
      padding-top: 75px;
    }
  }

  .content_wrap {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 0 20px 34px 20px;
    box-sizing: border-box;

    /* 底部的下载按钮 */
    .download_app_btn {
      margin-top: 30px;
    }

    .slide_down_img {
      height: 42px;
      margin: 0 0 30px;
      //background-image: url("../assets/img/introduction/small_hand_glides.gif");
      background-repeat: no-repeat;
      background-size: 65px 42px;
      background-position: center;
    }
    .introduction_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 55px;
      .introduction_p {
        width: 100%;
        height: auto;
        font-size: 14px;
        line-height: 23px;
        color: #333;
        text-align: left;
        margin-top: 31px;
        span {
          font-weight: bold;
        }
      }
      &.no_mt {
        margin-top: 0;
      }
      .introduction_item_titile {
        font-size: 21px;
        color: #333;
        line-height: 20.5px;
        text-align: center;
        position: relative;
      }
      .introduction_item_titile::before{
        content: "";
        position:absolute;
        width: 19px;
        height: 1px;
        background: linear-gradient(to right, #F2F2F2,#E0E0E0);
        //background-image: url('../assets/img/introduction_0730/line_1.png');
        //background-repeat: no-repeat;
        left: -28px;
        top: 50%;
        transform: translateY(-50%);
      }
      .introduction_item_titile::after{
        content: "";
        position:absolute;
        width: 19px;
        height: 1px;
        background: linear-gradient(to left, #F2F2F2,#E0E0E0);
        //background-image: url('../assets/img/introduction_0730/line_2.png');
        //background-repeat: no-repeat;
        right: -28px;
        top: 50%;
        transform: translateY(-50%);
      }

      .introduction_item_content {
        width: 100%;
        box-sizing: border-box;

        .introduction_brief {
          font-size: 13px;
          color: #9a5740;
          line-height: 20px;
          text-align: justify;

          padding: 4px 0 15px;
          .agq_name {
            font-size: 17px;
            font-weight: bold;
          }
          .flow_realization {
            font-size: 13px;
            font-weight: bold;
          }
        }

        .rank_info {
          height: 50px;
          background-repeat: no-repeat;
          background-size: 60px 60px;
          box-sizing: border-box;
          text-indent: 27px;
          padding-top: 20px;
          margin-top: 23.5px;
          &.rank_info_1 {
             background-image: url("../../assets/img/introduction_0730/01.png");
          }
          &.rank_info_2 {
             background-image: url("../../assets/img/introduction_0730/02.png");
          }
          &.rank_info_3 {
             background-image: url("../../assets/img/introduction_0730/03.png");
          }
          &.rank_info_4 {
            background-image: url("../../assets/img/introduction_0730/04.png");
          }
          &.rank_info_5 {
            background-image: url("../../assets/img/introduction_0730/05.png");
          }
          span {
            font-size: 17px;
            color: #333333;
            line-height: 26.5px;
            font-weight: bold;
            position: relative;
            top: 8px;
          }
          span::before{
            content: "";
            position: absolute;
            width: 13px;
            height: 13.5px;
            top: -8px;
            right: -15px;
             background-image: url("../../assets/img/introduction_0730/形状结合@2x(1).png");
            background-repeat: no-repeat;
            background-size: 13px 13.5px;
          }
        }
        .rank_info_p {
          padding-top: 30.5px;
          height: 75.5px;
          p {
            font-size: 14px;
            line-height: 20px;
            color: #333;
            white-space: nowrap;
            margin-bottom: 5px;
          }
        }
        /*单行样式 */
        .rank_info_line {
          height: 60px;
        }

        .introduction_item_text {
          margin-top: 2px;
          > p {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            margin-top: 5px;
          }
        }
        .introduction_item_text > p:first-child {
          margin-top: 0;
        }
        .introduce_wrap {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 12px;
          .introduce_1 {
            width: 335px;
            height: 351px;
            margin-top: 20px;
             background-image: url("../../assets/img/introduction_0730/banner_1.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .introduce_2 {
            width: 335px;
            height:325px;
            margin-top: 10px;
            margin-bottom: 12px;
             background-image: url("../../assets/img/introduction_0730/banner_2.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .introduce_3 {
            width: 335px;
            height: 289px;
            margin-top: 15.5px;
            margin-bottom: 3px;
             background-image: url("../../assets/img/introduction_0730/banner_3.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .introduce_4 {
            width: 335px;
            height: 208px;
            margin-top: 21px;
            margin-bottom: 12px;
             background-image: url("../../assets/img/introduction_0730/banner_4.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .introduce_5 {
            width: 335px;
            height: 339.8px;
            margin-top: 21px;
            margin-bottom: 12px;
            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/home/home_zx_banner.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .download_app_code {
            width: 178px;
            height: 178px;
            margin-top: 5px;
            margin-bottom: 12px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
          .personnel_code_wrap {
            width: 309px;
            height: 195px;
            margin-top: 5px;
            margin-bottom: 12px;
             background-image: url("../../assets/img/introduction/personnel_QR_code_bg@2x.png");
            background-size: 100%;
            background-repeat: no-repeat;
            box-sizing: border-box;
            padding: 25px 22px 0;
            display: flex;
            justify-content: space-between;
            > .personnel_code {
              width: 120px;
              height: 120px;
              > img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .license_plate_wrap {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 23.5px;
          margin-bottom: 10px;
          .license_plate_1 {
            .license_plate_1_bg {
              width: 118px;
              height: 155px;

              > img {
                width: 100%;
                height: 100%;
              }
            }
            .license_plate_1_text {
              height: 16px;
              font-size: 12px;
              color: #9a5740;
              line-height: 16px;
              text-align: center;
              margin-top: 3px;
            }
          }
          .license_plate_2 {
            .license_plate_2_bg {
              width: 258px;
              height: 190px;
              > img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .introduction_item_text_big {
          height: 22px;
          font-size: 15px;
          color: #9a5740;
          line-height: 22px;
          .download_app_text {
            text-decoration: underline;
          }
        }
        .contact_us_text {
          > p {
            height: 22px;
            font-size: 15px;
            color: #9a5740;
            line-height: 22px;
            text-align: center;
          }
        }
        .step_wrap {
          width: 100%;

          margin-top: 17px;
          .swiper-container {
            width: 100%;
            height: 375px;
            .swiper-img {
              width: 100%;
              height: auto;
            }
          }
          /*.swiper-pagination {
            position: static;
            height: 36px;
            padding-top: 15px;
            box-sizing: border-box;
          }*/
        }
      }
    }
  }
  .footer {
    height: 125px;
    background-color: #ff3131;
     background-image: url("../../assets/img/introduction/footer_bg@2x.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
    top: -0.5px;
  }
}
.introduce_end{
  color:#9A5740;
  p{
    font-size: 15px;
    text-align: center;
    margin-bottom: 22px;
  }
  ul{
    display:flex;
    flex-wrap: wrap;
  }
  li{
    font-size: 13px;
    flex: 0 0 50%;
    line-height: 20px;
    margin-bottom: 13px;
    padding-left: 25px;
    box-sizing:border-box;
  }
  .icon_wechat{
     background:url("../../assets/img/introduction/we_icon.png") no-repeat  left center / 20px 20px;
  }
  .icon_qq{
     background:url("../../assets/img/introduction/qq_icon.png") no-repeat left center / 20px 20px;
  }
  .icon_tel{
     background:url("../../assets/img/introduction/mobile_icon.png") no-repeat left center / 20px 20px;
  }
}
</style>
<style lang="scss">
body,html {
  height: 100%;
}
*{
  box-sizing: border-box;
}
//轮播图样式覆盖
.swiper-pagination {
  position: absolute;
  right: 20px;
  display: flex;
  flex-direction: column;
  top: 355px;

  .swiper-pagination-bullet {
    width: 16px;
    height: 16px;
    outline: none;
    background-color: transparent;
     background-image: url("../../assets/img/introduction_0730/gray_icon.png");
    background-size: 12px;
    background-repeat: no-repeat;
    opacity: 1;
    box-sizing: border-box;
    background-position: center;
    &.swiper-pagination-bullet-active {
       background-image: url("../../assets/img/introduction_0730/red_icon.png");
      background-size: 10px;
    }
  }
  .swiper-pagination-bullet:first-child {
    margin-left: 0;
  }
}

.swiper-slide img{
  width: 100%;
  height: auto;
  display: block;
}
</style>
<style scoped lang="scss">
.header_wrap {
  position: fixed;
  z-index: 1099;
  left: 0;
  right: 0;
  top: 0;
  height: 52px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  .header_icon {
    width: 89px;
    height: 32px;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .header_menu {
    width: 21px;
    height: 16px;
    position: relative;
    z-index: 2;
  }
}
.header_wrap::before{
  content: "";
  position: absolute;
  width: 100%;
  height: 6px;
  left: 0;
  right: 0;
  bottom: -5.5px;
  z-index:2;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.03), rgba(255, 255, 255, 0));
  opacity: .71;
}
/* 蒙层样式 */
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  outline: 0;
}

.modal-bg {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255,255,255,.96);
  opacity: 1;
  -webkit-transition: opacity .15s linear;
  transition: opacity .15s linear;
}

.modal-jc .modal-scroll {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  overflow: auto;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.modal-jc .modal-dialog {
  min-width: 66%;
  max-width: 90%;
  height: 100%;
  transition: all .3s ease-out;
  margin-top: 0;
  position: relative;
}

.modal-jc .modal-content {
  position: relative;
  border: 0.5px solid transparent;
  text-align: center;
  height: 100%;
  font-size: 19px;
  line-height: 26.5px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: initial;
  background-clip: padding-box;
  outline: 0;
  color: #333;

  .modal-item {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .modal-item.onCheck {
    color: #FF0909;
  }
}

/* 右上角按钮样式 - start */
.fixed-menu {
  width: 21px;
  height: 16px;
  display: inline-block;
  position: absolute;
  z-index:2;
  //transform: translateY(8px);
}

.fixed-menu>i {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  background-color: rgba(255,9,9,1);
  -webkit-transition: all .4s;
  transition: all .4s;
  top: 50%;
  z-index: 3;
}

.fixed-menu>i:first-child {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px)
}

.fixed-menu>i:last-child {
  -webkit-transform: translateY(8px);
  transform: translateY(8px)
}

.fixed-menu.close-menu>i:first-child {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg)
}



.fixed-menu.close-menu>i:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg)
}

.fixed-menu.close-menu>i:first-child {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg)
}

.fixed-menu.close-menu>i:nth-child(2) {
  -webkit-transform: scaleX(0);
  transform: scaleX(0)
}

.fixed-menu.close-menu>i:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg)
}

/* 切换菜单按钮样式 - end */

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.modal-enter-active {
  transition: all .3s ease;
}
.modal-leave-active {
  transition: all .3s ease;
}
.modal-enter, .modal-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.modal-leave-to .modal-dialog,.modal-enter .modal-dialog{
  -webkit-transform: scale(.8);
  transform: scale(.8)
}

/* 顶部标题 */
.header_content {
  text-align: center;
  font-size: 25px;
  line-height: 39px;
  color: #333;
  letter-spacing: 0.94px;
}
/* 副标题 */
.header_summary {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 46px 38px 0;
  dl {
    text-align: center;
    dt{
      width: 30px;
      height: 30px;
      margin: 0 auto 8px;
      img{
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    dd {
      font-size: 14px;
      line-height: 18px;
      color: #7F7F7F;
    }
  }
}
/* 下载按钮 */
.download_app_btn {
  width: 189px;
  height: 40px;
  margin: 55px auto 0;
  border-radius: 20px;
  background-color: #FF3235;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
}
/* 标题背景图 */
.header_bg {
  width: 100%;
  height: 59px;
  margin-top: 67px;
  > img{
    width: 100%;
    height: 100%;
    display: block;
  }
}
/* 轮播图框架 */
.introduction_item_swipe {
  padding: 15px 18px 0 17.5px;
}
.introduction_item_content_swipe {
  width: 100%;
  height: 457px;
  //height: 419.5px;
   background-image:url("../../assets/img/introduction_0730/手机模型@2x.png");
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 37.5px 29px 0 29.5px;
  box-sizing: border-box;
  overflow: hidden;
}
.about_us {
  margin-top: 19.5px;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
  padding-top: 12.5px;
  position: relative;
  z-index: 2;
  .content {
    width: 100%;
    height: auto;
    background-color: #FAFAFA;
    padding: 15px 18px;
    box-sizing: border-box;
    p {
      font-size: 14px;
      line-height: 20px;
      color: #333;
      margin-bottom: 8px;
    }
  }
  .content p:last-of-type {
    margin-bottom: 0;
  }
}
.about_us::before{
  content: '';
  z-index: 1;
  position: absolute;
   background-image: url("../../assets/img/introduction_0730/摘要@2x.png");
  background-repeat: no-repeat;
  background-size: 26.5px 25px;
  top: 0;
  left: 0;
  width: 26.5px;
  height: 25px;
}
.concat {
  margin-top: 15px;
  width: 100%;
  height: auto;
  background: #FAFAFA;
  padding: 15px 18px 16.5px 18px;
  p {
    font-size: 14px;
    line-height: 20px;
    color: #333;
    margin-bottom: 8px;
  }
  ul {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      display: inline-block;
      height: 20px;
      padding-left: 28px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 13px;
      color: #636363;
    }
    .qq{
       background:url("../../assets/img/introduction_0730/QQ (1)@2x.png");
      background-repeat: no-repeat;
      background-size: 20px;
    }
    .wx{
       background:url("../../assets/img/introduction_0730/微信@2x.png");
      background-repeat: no-repeat;
      background-size: 20px;
    }
    .tel{
       background:url("../../assets/img/introduction_0730/编组 16@2x.png");
      background-repeat: no-repeat;
      background-size: 20px;
      margin-bottom: 0;
    }
  }
}
footer{
  p {
    font-size: 10px;
    line-height: 17.5px;
    color: #AAA;
    text-align: center;
  }
}
</style>
